// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2HN5X","title":"InfoRow_title__rZ1c6"};